import styled from 'styled-components';

import {
  BodySmallMedium,
  BodySmallRegular,
  BodyStandardMedium,
  BodyStandardRegular,
  BodyStandardSemiBold,
  Colour,
} from '@xemplo/style-constants';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: ${Colour.Gray[600]};
`;

export const DescriptionHeading = styled.div`
  ${BodyStandardSemiBold};
`;

export const DescriptionBody = styled.div`
  ${BodyStandardRegular};
`;

export const Card = styled.div`
  background: ${Colour.Gray[50]};
  border-radius: 8px;
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${Colour.Gray[200]};
  }
`;

export const RowLabel = styled.span`
  ${BodySmallMedium};
  color: ${Colour.Gray[600]};
`;

export const RowValue = styled.span`
  ${BodyStandardMedium};
  color: ${Colour.Gray[900]};
  text-align: right;
`;

export const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CheckboxRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const CheckboxTick = styled.div`
  padding-top: 3px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: 2px;
  cursor: pointer;
`;

export const CheckboxTitle = styled.span`
  ${BodySmallMedium};
  color: ${Colour.Gray[900]};
`;

export const CheckboxHint = styled.span`
  ${BodySmallRegular};
  color: ${Colour.Gray[500]};
`;
